import { MAX_INCOMPLETE_UPLOADS } from '../config/constants';
import type { UploadTask } from '../types/uploads';
import { isTerminalPhase } from './uploadLifecycle';

/** A transfer still doing work. Failed/cancelled attempts are history and do not consume capacity. */
export function isIncompleteTransfer(item: UploadTask): boolean {
  return !isTerminalPhase(item.phase) && item.phase !== 'error';
}

export function incompleteUploadCount(items: UploadTask[]): number {
  // Legacy video rows predate mediaType and therefore intentionally count as videos.
  return items.filter(
    (item) => item.channel === 'upload' && item.mediaType !== 'mcap' && isIncompleteTransfer(item),
  ).length;
}

export function remainingUploadCapacity(items: UploadTask[]): number {
  return Math.max(0, MAX_INCOMPLETE_UPLOADS - incompleteUploadCount(items));
}

export class UploadQueueLimitError extends Error {
  constructor(
    readonly current: number,
    readonly requested: number,
  ) {
    super('incomplete_upload_limit_exceeded');
    this.name = 'UploadQueueLimitError';
  }

  get remaining(): number {
    return Math.max(0, MAX_INCOMPLETE_UPLOADS - this.current);
  }
}
